import { Controller, useForm } from "react-hook-form";
import Button from "../../../../components/Button";
import SelectField from "../../../../components/SelectField";
import { CANCELLATION_REASONS } from "../../../../constant";
import { connect, useDispatch } from "react-redux";
import { isScopeLoading } from "../../../../store/scope-loading/helpers";
import { ContractScope } from "../../../../store/contract/types";
import { RootState } from "../../../../store/root-reducer";
import {
  calculateRefundAmount,
  cancelContract,
  cleanUpContract,
} from "../../../../store/contract/actions";
import SuccessModal from "../../../SubmitTicket/Modal/SuccessModal";
import useToggle from "../../../../hooks/useToggle";
import { USDollar } from "../../../../helper";
import { FaSpinner } from "react-icons/fa";
import { useEffect } from "react";
import RouteNames from "../../../../routes/type";
import { useNavigate } from "react-router";

function CancelPlanModal({
  contract,
  loading,
  onClose,
  onSucessClose,
  loggedUserEmail,
  isOpen,
  isRefundAmountCalculating,
  isActiveClaim,
}) {
  const { control, handleSubmit } = useForm({
    shouldUnregister: true,
  });
  const navigate = useNavigate();
  const {
    value: showCancelltionSucess,
    setFalse: hideCancelltionSucessModal,
    setTrue: showCancelltionSucessModal,
  } = useToggle(false);

  const dispatch = useDispatch();
  const onSubmit = (values) => {
    dispatch(
      cancelContract(
        contract.id,
        {
          refund_amount: contract.calculatedRefundAmount,
          plan_number: contract.name,
          denial_reason_code: values.cancellation_reason?.value,
          deanial_reason: values.comments,
          contact_email: loggedUserEmail || "no@email.com",
        },
        () => {
          onClose();
          showCancelltionSucessModal();
        }
      )
    );
  };

  useEffect(() => {
    if (
      !contract.calculatedRefundAmount &&
      contract.id &&
      isOpen &&
      !isActiveClaim
    ) {
      dispatch(calculateRefundAmount());
    }
  }, [
    contract.calculatedRefundAmount,
    contract.id,
    dispatch,
    isActiveClaim,
    isOpen,
  ]);

  const handleSubmitTicket = () => {
    navigate(RouteNames.SUBMIT_TICKET);
  };

  return (
    <>
      {isOpen && (
        <div className="fixed inset-0 z-10 h-full w-full overflow-y-auto bg-black/50 flex justify-center items-center">
          <div className="w-full max-w-md rounded-lg p-6 bg-white grid gap-6">
            {isRefundAmountCalculating ? (
              <div
                className="flex items-center gap-2 justify-center text-lg text-gray-700"
                aria-live="polite"
              >
                <FaSpinner
                  className="animate-spin text-blue-500"
                  aria-hidden="true"
                />
                <span>Calculating your refund amount...</span>
              </div>
            ) : isActiveClaim ? (
              <div className="flex flex-col items-center gap-4 text-center">
                <p className="text-gray-800">
                  The plan selected for cancellation currently has an active
                  claim, please use the “Submit Ticket” to contact us regarding
                  the plan.
                  <br />
                  Thank you!
                </p>
                <div className="flex items-center gap-3 justify-end w-full">
                  <Button
                    variant="blue"
                    btnClassName="w-full"
                    onClick={handleSubmitTicket}
                  >
                    Submit Ticket
                  </Button>
                  <Button
                    variant="gray"
                    onClick={onClose}
                    btnClassName="w-full"
                  >
                    Close
                  </Button>
                </div>
              </div>
            ) : (
              <>
                <h2 className="text-center text-lg">Cancel Plan</h2>
                <form onSubmit={handleSubmit(onSubmit)} className="grid gap-3">
                  <div className="flex gap-2">
                    <p className="text-base text-gray-600 ">
                      Calculated Refund Amount:
                    </p>
                    <p className="font-semibold text-base text-gray-800 break-all">
                      {contract.calculatedRefundAmount === null
                        ? "Please contact support"
                        : USDollar.format(contract.calculatedRefundAmount || 0)}
                    </p>
                  </div>
                  <SelectField
                    name="cancellation_reason"
                    control={control}
                    label="Cancellation Reason"
                    options={CANCELLATION_REASONS}
                    required
                  />
                  <div>
                    <label className="inline-block text-gray-500 pb-1 text-sm">
                      Comments
                    </label>
                    <Controller
                      control={control}
                      name="comments"
                      render={({ field }) => (
                        <textarea
                          {...field}
                          name="comments"
                          className="w-full border border-gray-300 px-3 py-2.5 rounded-lg text-gray-800 placeholder-gray-500 focus:outline-none focus:shadow-none focus:ring-0 focus:border-gray-900 text-sm bg-gray-50 resize-none"
                          placeholder="Write here..."
                          rows={5}
                        />
                      )}
                    />
                  </div>
                  <div className="flex items-center gap-3 justify-end w-full">
                    <Button
                      variant="gray"
                      onClick={onClose}
                      btnClassName="w-full"
                      disabled={loading}
                    >
                      Close
                    </Button>
                    <Button
                      variant="blue"
                      type="submit"
                      btnClassName="w-full"
                      isLoading={loading}
                    >
                      Submit
                    </Button>
                  </div>
                </form>
              </>
            )}
          </div>
        </div>
      )}
      <SuccessModal
        isOpen={showCancelltionSucess}
        close={() => {
          hideCancelltionSucessModal();
          onSucessClose();
          dispatch(cleanUpContract());
        }}
        textMsg="Plan Cancellation Request Received"
      />
    </>
  );
}

const mapStateToProps = (state: RootState) => ({
  contract: state.contract,
  loading: isScopeLoading(state.scopeLoading, `cancel-${ContractScope}`),
  isActiveClaim: state.contract.isActiveClaim || false,
  isRefundAmountCalculating: isScopeLoading(
    state.scopeLoading,
    `${ContractScope}-calculate-amount`
  ),
  loggedUserEmail: state.user.email,
});

export default connect(mapStateToProps)(CancelPlanModal);
